
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-63f2a916\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../../../node_modules/@zbj/vue-mixin-loader/index.js??ref--1!./index.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../../../node_modules/@zbj/vue-mixin-loader/index.js??ref--1!./index.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-63f2a916\",\"preserveWhitespace\":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../../../node_modules/@zbj/vue-mixin-loader/index.js??ref--1!./index.vue"),
  /* scopeId */
  "data-v-63f2a916",
  /* cssModules */
  null
)
Component.options.__file = "D:\\zhubajie\\Project\\nodejs-zbjfins-web\\app\\resource\\page\\index\\views\\index.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] index.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63f2a916", Component.options)
  } else {
    hotAPI.reload("data-v-63f2a916", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/index.vue
// module id = 1171
// module chunks = 2